import { useQuery } from "@tanstack/react-query";
import queryKeys from "../../constants/queryKeys";
import documentService from "../../services/documentService";

const useAccountFiles = (
    accountId: number | string | undefined,
    fileTypeHS: number,
    documentType: number,
) =>
    useQuery({
        queryKey: [queryKeys.accountFiles, fileTypeHS, accountId],
        queryFn: () => documentService.fetchAccountFiles(accountId, fileTypeHS, documentType),
        enabled: !!accountId || !!fileTypeHS,
    });

export default useAccountFiles;
